document.addEventListener("DOMContentLoaded", function () {

        const checkboxes = document.querySelectorAll('.rs-ml-accordion-item input[type="checkbox"]');
        checkboxes.forEach(function (checkbox) {
            checkbox.addEventListener("change", function () {
                checkboxes.forEach(function (otherCheckbox) {
                    if (otherCheckbox !== checkbox) {
                        otherCheckbox.checked = false;
                    }
                });
            });
        });

});